import type { CommonResponseParentOnRelationDto } from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import { type ParentChildren, ParentChildrenSchema } from './schemas'

export const adaptParentChildren = (
  raw: CommonResponseParentOnRelationDto['data'],
): ParentChildren => parseApiResponse(ParentChildrenSchema, raw, 'Parent')
